import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  getCriticsSuggestionsService,
  editCriticsSuggestionService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const criticsSuggestionsAdminContext = createContext({
  criticsSuggestions: [],
  setCriticsSuggestions: () => {},
  criticsSuggestion: {},
  setCriticsSuggestion: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleGetCriticsSuggestions: () => {},
  handleEditCriticsSuggestion: () => {},
});

const CriticsSuggestionsAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [criticsSuggestions, setCriticsSuggestions] = useState([]);
  const [criticsSuggestion, setCriticsSuggestion] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  // Handle Get Critics Suggestions Method
  const handleGetCriticsSuggestions = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getCriticsSuggestionsService(objData);
      if (status === 200) {
        setCriticsSuggestions(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Critics Suggestion Method
  const handleEditCriticsSuggestion = async () => {
    const objData = {
      id: criticsSuggestion.id,
      view: true,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editCriticsSuggestionService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ویرایش شد");
        handleGetCriticsSuggestions();
        setCriticsSuggestion({});
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <criticsSuggestionsAdminContext.Provider
      value={{
        criticsSuggestions,
        setCriticsSuggestions,
        criticsSuggestion,
        setCriticsSuggestion,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        handleGetCriticsSuggestions,
        handleEditCriticsSuggestion,
      }}
    >
      {children}
    </criticsSuggestionsAdminContext.Provider>
  );
};

export default CriticsSuggestionsAdminContext;
